import { Paragraph, Stack } from '@contentful/f36-components';
import { useSDK } from '@contentful/react-apps-toolkit';
import ArticleMigration from '../components/ArticleMigration';
import SectionMigration from '../components/SectionMigration';

const SECTION_CONTENT_TYPES = [
  'sectionActionCard',
  'sectionQuickAccess',
  'sectionHeroCarousel',
  'smallPortraitCarousel',
  'sectionTextualContent',
  'sectionTextualContentGroup'
];

const Sidebar = () => {
  const sdk = useSDK();

  const entryId = sdk.entry.getSys().id;
  const contentType = sdk.entry.getSys().contentType.sys.id;

  const isArticle = contentType === 'article';
  const isSection = SECTION_CONTENT_TYPES.includes(contentType);

  if (!isArticle && !isSection) {
    return (
      <Stack flexDirection="column" alignItems="center" justifyContent="center" style={{ height: '100vh', padding: '1rem' }}>
        <Paragraph style={{ textAlign: 'center' }} marginBottom='none'>
          This application is designed to work with article and section content types only.
        </Paragraph>
      </Stack>
    );
  }

  if (isArticle) {
    return <ArticleMigration sdk={sdk} entryId={entryId} />;
  }

  return <SectionMigration sdk={sdk} entryId={entryId} />;
};

export default Sidebar;
